import { Joi, actionCreator, literalAs, objectSchemaOf } from '../helpers';
import { KEEP_WARM_INPUT } from './topics';

export const WARM_UP = 'KEEP_WARM/WARM_UP' as const;

export interface IWarmUpMessage {
  type: typeof WARM_UP;
}

export const warmUpActionSchema = objectSchemaOf<IWarmUpMessage>({
  type: Joi.string().valid(WARM_UP).required(),
});

export const warmUp = actionCreator({
  type: WARM_UP,
  topic: KEEP_WARM_INPUT,
  schema: warmUpActionSchema,
  creator: () => literalAs<IWarmUpMessage>({ type: WARM_UP }),
});
